"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentPlanPaymentEventsToJSON = exports.PaymentPlanPaymentEventsFromJSONTyped = exports.PaymentPlanPaymentEventsFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function PaymentPlanPaymentEventsFromJSON(json) {
    return PaymentPlanPaymentEventsFromJSONTyped(json, false);
}
exports.PaymentPlanPaymentEventsFromJSON = PaymentPlanPaymentEventsFromJSON;
function PaymentPlanPaymentEventsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'maturityDate': json['maturityDate'],
        'amount': !(0, runtime_1.exists)(json, 'amount') ? undefined : (0, _1.AmountFromJSON)(json['amount']),
        'details': !(0, runtime_1.exists)(json, 'details') ? undefined : (json['details'].map(_1.PaymentPlanDetailsFromJSON)),
    };
}
exports.PaymentPlanPaymentEventsFromJSONTyped = PaymentPlanPaymentEventsFromJSONTyped;
function PaymentPlanPaymentEventsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'maturityDate': value.maturityDate,
        'amount': (0, _1.AmountToJSON)(value.amount),
        'details': value.details === undefined ? undefined : (value.details.map(_1.PaymentPlanDetailsToJSON)),
    };
}
exports.PaymentPlanPaymentEventsToJSON = PaymentPlanPaymentEventsToJSON;
//# sourceMappingURL=PaymentPlanPaymentEvents.js.map